import { kongApi } from 'packages/common/helpers/api';

const api = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PERSONNEL_DEPARTMENT}/`,
});

export default {
  getHolidays(year) {
    return api.get(`feriados/anos/${year}`);
  },
  create(holiday) {
    return api.post('feriados', holiday);
  },
  deleteHoliday(id) {
    return api.delete(`feriados/${id}`);
  },
  getLatestIrrf() {
    return api.get('tabelas/irrf');
  },
  getNextIrrf(id) {
    return api.get(`tabelas/irrf/${id}/proxima`);
  },
  getPreviousIrrf(id) {
    return api.get(`tabelas/irrf/${id}/anterior`);
  },
  getPreviousInssTable(id) {
    return api.get(`tabelas/inss/${id}/anterior`);
  },
  getNextInssTable(id) {
    return api.get(`tabelas/inss/${id}/proxima`);
  },
  getCurrentInssTable() {
    return api.get('tabelas/inss');
  },
};
